import React from 'react'

import Dynamic from './components/Dynamic'

import classes from './styles'

function generateId() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

function getParameterImages(parameter) {
  const imageName = parameter.code === 'popularity' ? 'man' : 'coin'
  let scoreInImage = parameter.score / 2

  if (scoreInImage < 0) scoreInImage = 0
  if (scoreInImage > 5) scoreInImage = 5

  const fulls = Math.floor(scoreInImage)
  const isHalf = scoreInImage % 1 > 0
  let rest = 5 - fulls

  if (isHalf) rest -= 1

  return (
    <div>
      {[...Array(fulls)].map((_, i) => (
        <img
          key={`full-${i}`}
          className={[classes.image, classes[imageName]].join(' ')} src={`https://10years.lifehacker.ru/publisher/images/${imageName}.svg`}
          alt=""
        />
      ))}
      {isHalf ?
        <img
          className={[classes.image, classes[imageName]].join(' ')} src={`https://10years.lifehacker.ru/publisher/images/half-${imageName}.svg`}
          alt=""
        />
      :''}
      {[...Array(rest)].map((_, i) => (
        <img
          key={`rest-${i}`}
          className={[classes.image, classes[imageName]].join(' ')} src={`https://10years.lifehacker.ru/publisher/images/non-${imageName}.svg`}
          alt=""
        />
      ))}
    </div>
  )
}

class Score extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      score: props.score,
      roundId: null,
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => this.state.roundId !== nextState.roundId

  componentWillReceiveProps = (nextProps) => {
    setTimeout(() => {
      this.setState({
        score: nextProps.score,
        roundId: generateId(),
      })
    }, 1600)
  }

  render() {
    const { score } = this.state
    const popular = score.find(parameter => parameter.code === 'popularity')
    const profit = score.find(parameter => parameter.code === 'profitability')

    const popularImages = getParameterImages(popular)
    const profitImages = getParameterImages(profit)
    return (
      <div className={classes.score}>
        <div className={[classes.parameterWrapper, classes.coins].join(' ')}>
          <div className={classes.parameter}>
            <div className={classes.images}>
              {profitImages}
            </div>

            <Dynamic dynamic={profit.dynamic} />
          </div>
        </div>

        <div className={classes.parameterWrapper}>
          <div className={classes.parameter}>
            <div className={classes.images}>
              {popularImages}
            </div>

            <Dynamic dynamic={popular.dynamic} />
          </div>
        </div>
      </div>
    )
  }
}

Score.propTypes = {
  score: React.PropTypes.array.isRequired,
}

export default Score


// WEBPACK FOOTER //
// ./src/components/Score/Score.jsx